import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

export const stagger = (delayChildren = 0.08) => ({
  hidden: {},
  show: { transition: { staggerChildren: delayChildren } },
});

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
};

export function Reveal({ children, className, delay = 0, as = 'div', y = 28, ...rest }) {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </C>
  );
}

export function Stagger({ children, className, as = 'div', gap = 0.08, ...rest }) {
  const C = motion[as];
  return (
    <C
      className={className}
      variants={stagger(gap)}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: '-60px' }}
      {...rest}
    >
      {children}
    </C>
  );
}

export function Item({ children, className, as = 'div', ...rest }) {
  const C = motion[as];
  return (
    <C className={className} variants={fadeUp} {...rest}>
      {children}
    </C>
  );
}
